import { METHOD } from './constants';

class ApiClient {

    constructor() {}

    get(serverUrl, requestUrl, payload = {}, authToken = null) {
        return this.request({
            serverUrl,
            url: requestUrl,
            method: METHOD.GET,
            body: payload,
            authToken
        });
    }

    put(serverUrl, requestUrl, payload = {}, authToken = null) {
        return this.request({
            serverUrl,
            url: requestUrl,
            method: METHOD.PUT,
            body: payload,
            authToken
        });
    }

    post(serverUrl, requestUrl, payload = {}, authToken = null) {
        return this.request({
            serverUrl,
            url: requestUrl,
            method: METHOD.POST,
            body: payload,
            authToken
        });
    }

    delete(serverUrl, requestUrl, authToken = null) {
        return this.request({
            serverUrl,
            url: requestUrl,
            method: METHOD.DELETE,
            authToken
        });
    }

    request({ serverUrl, url, method, params = {}, body, authToken = null }) {
        throw 'Method request in ApiClient not realized';
    }
}

export default ApiClient;


// WEBPACK FOOTER //
// ./~/pluton-core/lib/api/ApiClient.js